import { create } from 'zustand';

interface SubmitWarningStore {
  isOpen: boolean;
  show: () => void;
  dismiss: () => void;
}

// Drives the post-submit warning dialog that informs the user their file is
// uploading in the background and may be lost if they close the browser /
// switch device / leave the app for >24h. Lives in its own store so the
// trigger (RequestFormModal.onSubmit) and the mount point (RequestWizard) are
// decoupled — the form's dialog can close immediately while the warning stays
// open until the user dismisses it.
export const useSubmitWarningStore = create<SubmitWarningStore>((set) => ({
  isOpen: false,
  show: () => set({ isOpen: true }),
  dismiss: () => set({ isOpen: false }),
}));
